import { ILink } from "@/models/link.model"
import { umbracoApi } from "~/utils/axios.util"

export interface ISearchResponse {
    Total: number
    Items: ISearchItem[]
}

export interface ISearchItem {
    Id: number
    Title: string
    Intro: string
    Link: ILink
    Tags: string[] | null
    Date: Date | null
    Url: string
}

export interface ISearchParams {
    query: string
    skip: number
    take: number
    pageId: string
    culture: string
}

export const SearchRepository = {
    Get: (params: ISearchParams, url: string = "/search/get") =>
        umbracoApi.get<ISearchResponse>(url, {
            params,
        }),
}
